.toggle {
  position: absolute;
  bottom: 10px;
  left: 10px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgb(255 255 255 / 95%);
  border: 1.5px solid var(--colors-grays-light);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  z-index: var(--layers-visible);
  color: var(--colors-grays-black);
  backdrop-filter: blur(4px);
  padding: 0;
}

.toggle:hover {
  border-color: var(--colors-primary-main);
  background: var(--colors-grays-white);
}

.toggle svg {
  width: 16px;
  height: 16px;
}

.toggle__active {
  background: var(--colors-primary-main);
  border-color: var(--colors-primary-main);
  color: var(--colors-grays-white);
}

.toggle__active:hover {
  background: var(--colors-primary-dark);
  border-color: var(--colors-primary-dark);
}

@media (--reefer-media-tablet-max) {
  .toggle {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    bottom: 8px;
    left: 8px;
  }

  .toggle svg {
    width: 14px;
    height: 14px;
  }
}
